import { useContext, useEffect } from 'react';

import { NETWORK_ERROR } from 'configs/messages';
import {
  CounterpartyCard,
  CounterpartyBasicInfoFragment,
} from 'features/deals/dealCards/CounterpartyCard';
import ListingStratsCard, {
  ListingStratsCardFragments,
} from 'features/deals/dealCards/ListingStratsCard';
import { PoolHeaderFragments } from 'features/loanPool/PoolHeader';
import { useParams } from 'react-router-dom';
import { styled } from 'style/ORSNNTheme';

import { gql, useQuery } from '@apollo/client';

import { GetListing, GetListingVariables } from './__generated__/GetListing';
import ListingSidebar, { ListingSidebarFragments } from './ListingSidebar';
import { DataContext, DataContextActionType } from '../../context/DataContext';

type ListingParams = {
  asset_class?: string;
  listing_id: string;
};

const GET_LISTING_QUERY = gql`
  query GetListing($id: ID!) {
    listing(id: $id) {
      id
      ...PoolHeaderListing
      ...ListingStratsCardListing
      ...ListingSidebarListing
      company {
        ...CounterpartyBasicInfo
      }
    }
  }
  ${PoolHeaderFragments.listing}
  ${ListingStratsCardFragments.listing}
  ${CounterpartyBasicInfoFragment.company}
  ${ListingSidebarFragments.listing}
`;

const ListingOverview = (): JSX.Element => {
  const params = useParams<ListingParams>();
  const { dispatch } = useContext(DataContext);

  const { loading, error, data } = useQuery<GetListing, GetListingVariables>(GET_LISTING_QUERY, {
    variables: { id: params.listing_id || '' },
    fetchPolicy: 'cache-and-network',
  });

  useEffect(() => {
    dispatch({
      type: DataContextActionType.SET_LOADING,
      payload: loading,
    });
  }, [loading]);

  if (error) {
    console.log(`Listing Error! ${error.message}`);
    return <>{NETWORK_ERROR}</>;
  }

  const listing = data?.listing;

  if (listing == null) {
    return <></>;
  }

  console.log('listing', listing);

  // TODO reuse DealRoom code to build out the view for a public offering
  // TODO add the Request Access button and modal
  // TODO add the Pool Summary and Stratifications
  // TODO make sure no filtering is allowed in this view
  // Note - the PoolHeader here is for the old offering view, not the new one
  // return (
  //   <>
  //     <Table>
  //       <PoolHeader listing={listing} showContactSellerButton />
  //       <PoolSummary totalData={listing?.performanceData} />
  //     </Table>
  //   </>
  // );
  return (
    <div className="bg-bgCanvas flex h-full flex-row gap-2 overflow-auto rounded-lg p-3 [grid-area:page]">
      <ListingSidebar listing={listing} />
      <div className="max-w-[75%] flex-shrink-0 flex-grow-0 basis-3/4">
        <CounterpartyCard
          {...listing}
          active={true}
          counterparty={listing.company}
          loading={false}
        />
        <ListingStratsCard {...listing} loading={false} />
      </div>
    </div>
  );
};

export default ListingOverview;
